/*
 * ManageRolePermissions Messages
 *
 * This contains all the text for the ManageRolePermissions container.
 */

import { defineMessages } from 'react-intl';

export const scope = 'app.containers.ManageRolePermissions';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Privileges',
  },
});
